var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// stylesheet
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
import "../orderbook.scss";
import MutualFundTransactionsTable from "@frameworks/shared-library/components/Orderbook/common/MutualFundTransactionsTable/MutualFundTransactionsTable";
import OrderBookDetail from "../detail/OrderBookDetail";
// helpers
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { EValueType, } from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import { tabData } from "../../../../constants/constant";
import { NavLink } from "react-router-dom";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import actions from "@mainDi/features/AIF-PMS/actions";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { ILoginTypeEnum } from "@domains/salesFeatures/Login/entities/iLogin";
var PmsOrdersTable = function (props) {
    var _a;
    var searchParams = new URLSearchParams(location.search);
    var _b = __read(useState(null), 2), orderDetails = _b[0], setOrderDetails = _b[1];
    var categoryCode = searchParams.get("categoryCode");
    var productCode = searchParams.get("productCode");
    var orderId = searchParams.get("orderId");
    var productType = searchParams.get("productType");
    var ordertype = searchParams.get("ordertype");
    var navigate = useNavigate();
    var orderBook = useSelector(function (state) { return state.markets.orderBook; }).orderBookDetails;
    var cActions = actions();
    var orderBookDetails = orderBook === null || orderBook === void 0 ? void 0 : orderBook.data;
    var handleTableRowClick = function (data) {
        setOrderDetails(data);
        if ((data === null || data === void 0 ? void 0 : data.transactionId) || (data === null || data === void 0 ? void 0 : data.orderid)) {
            aifPmsDi.orderBook.orderbookdetails({
                CategoryCode: props.subCategoryId,
                TransactionId: (data === null || data === void 0 ? void 0 : data.order_type) == "T" ? data === null || data === void 0 ? void 0 : data.transactionId : data === null || data === void 0 ? void 0 : data.orderid,
                ordertype: data === null || data === void 0 ? void 0 : data.order_type,
            });
            props.setOpenSB(true);
        }
    };
    var partnerCategory = localStorage.getItem(ELocalStorageKeys.LoginType);
    var details = __spreadArray([
        {
            label: "Form Number",
            value: (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.formNumber) ? orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.formNumber : "-",
            valueType: EValueType.TEXT,
        },
        {
            label: "Application Type",
            value: (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.applicationType)
                ? orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.applicationType
                : "-",
            valueType: EValueType.TEXT,
        },
        {
            label: "Series",
            value: (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.series) ? orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.series : "-",
            valueType: EValueType.TEXT,
        },
        {
            label: "Setup Fee",
            value: (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.setupFee) != null
                ? (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.setupFee) + "%"
                : "-",
            valueType: EValueType.TEXT,
        },
        {
            label: "Fund Status & Date",
            value: (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.fundStatusDate)
                ? orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.fundStatusDate
                : "-",
            valueType: EValueType.TEXT,
        },
        {
            label: "Lead ID",
            value: (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.leadId) ? orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.leadId : "-",
            valueType: EValueType.TEXT,
        },
        {
            label: "Wealth Manager",
            value: (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.wealthManager)
                ? orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.wealthManager
                : "-",
            valueType: EValueType.TEXT,
        },
        {
            label: "CXO Status",
            value: (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.cxoStatus) ? orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.cxoStatus : "-",
            valueType: EValueType.TEXT,
        }
    ], __read((partnerCategory !== ILoginTypeEnum.PARTNER
        ? [
            {
                label: "SB Code",
                value: (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.is_CTA) ? ((orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.sbCode) ? (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.sbCode) : (React.createElement(NavLink, { to: "", className: "txt-han-blue RobotoM_13_400 fw-400", onClick: function () { return props.setAddBrokerVisible(true); } },
                    React.createElement("u", null, (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.passout) ? "Edit" : "Add")))) : (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.sbCode) ? (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.sbCode) : ("-"),
                valueType: EValueType.NUMBER,
            },
            {
                label: "Passout",
                value: (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.is_CTA) ? ((orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.passout) || (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.sbCode) ? (React.createElement("div", { className: "d-flex gap-1" },
                    React.createElement("span", null, (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.passout) != null
                        ? (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.passout) + "%"
                        : ""),
                    React.createElement(NavLink, { to: "", className: "txt-han-blue RobotoM_13_400 fw-400", onClick: function () { return props.setAddBrokerVisible(true); } },
                        React.createElement("u", null, "Edit")))) : (React.createElement(NavLink, { to: "", className: "txt-han-blue RobotoM_13_400 fw-400", onClick: function () { return props.setAddBrokerVisible(true); } },
                    React.createElement("u", null, "Add")))) : (orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.passout) != null ? ((orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.passout) + "%") : (""),
                valueType: EValueType.NUMBER,
            },
        ]
        : [])), false);
    var handleNavigate = useCallback(function () {
        navigate("/dashboard/product-bouquet", {
            state: {
                select: {
                    label: "Managed Portfolio",
                    value: "56",
                    mfL3LevelData: tabData,
                },
                tabId: props.subCategoryId,
                productName: { label: "Wealth Product", value: "Wealth Product" },
            },
        });
    }, [navigate, tabData, props]);
    useEffect(function () {
        if (productType &&
            productCode &&
            categoryCode &&
            orderId &&
            ordertype &&
            props.subCategoryId === Number(categoryCode)) {
            cActions.orderBook.orderbookdetails(null);
            aifPmsDi.orderBook.orderbookdetails({
                CategoryCode: Number(categoryCode),
                TransactionId: Number(orderId),
                ordertype: String(ordertype),
            });
            props.setOpenSB(true);
        }
    }, [categoryCode, productCode, productType, orderId]);
    return (React.createElement("div", { className: "primary-mandate-transactions-container ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement(MutualFundTransactionsTable, { columns: props.tableColumns, data: props.tableData, rowOnClick: handleTableRowClick, showViewAll: props.showViewAll, viewAllOnClick: props === null || props === void 0 ? void 0 : props.viewAllOnClick, showShimmer: props === null || props === void 0 ? void 0 : props.showShimmer, selectedSortColumnVal: props.selectedSortColumnVal
                ? props.selectedSortColumnVal
                : String(props === null || props === void 0 ? void 0 : props.defaultSortingColumnKey), selectedSortVal: String(props === null || props === void 0 ? void 0 : props.selectedSortVal), errorScreenBtnCallback: handleNavigate, mfCustomError: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                React.createElement("p", { className: "DMSanN_14_400" }, props.errorScreenMessage),
                React.createElement(EdButton, { btnTyp: "tomato", onClick: handleNavigate, value: "Invest Now!", className: "d-flex align-items-center justify-content-center DMSanN_13_500" })), callbackSorted: props === null || props === void 0 ? void 0 : props.callbackSorted }),
        React.createElement(OrderBookDetail, { visible: props.openSB, setVisible: props.setOpenSB, details: details, orderDetails: orderDetails, addBrokerVisible: props.addBrokerVisible, setAddBrokerVisible: props.setAddBrokerVisible, subCategoryId: props.subCategoryId, onSuccessPassoutAndEmpDetails: props.onSuccessPassoutAndEmpDetails })));
};
export default PmsOrdersTable;
